import { render, staticRenderFns } from "./softwareLis.vue?vue&type=template&id=2b1a5da0&scoped=true&"
import script from "./softwareLis.vue?vue&type=script&lang=ts&"
export * from "./softwareLis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a5da0",
  null
  
)

export default component.exports